/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


import { NbAuthService } from '../auth.service';

@Component({
  selector: 'nb-logout',
  template: `
    <div>Logging out, please wait...</div>
  `,
})
export class NbLogoutComponent implements OnInit {

  constructor(protected service: NbAuthService,protected router: Router) {
  }

  ngOnInit(): void {
    this.logout();
  }

  logout(): void {
    localStorage.clear()
    this.router.navigateByUrl("/auth/login");
  }

}
